export default {
  hero: {
    title: '关于Global Data',
    subtitle: '创新科技，赋能未来'
  },
  
  companyIntro: {
    title: '公司简介',
    paragraph1: 'Global Data是专注于亚太地区IT基础设施服务的专业提供商。凭借对本地市场的深入洞察与全球技术视野，我们为企业数字化转型奠定坚实的技术基石。过去二十年来，我们持续为众多世界知名企业提供高效、安全、可靠的服务支持。',
    paragraph2: '我们的服务网络覆盖亚太主要商业中心，通过本地化团队与全球化资源的结合，为跨国企业和本地机构提供无缝衔接的技术解决方案。从基础设施规划到实施运维，Global Data全程陪伴客户的数字化之旅。'
  },
  
  missionVision: {
    title: '我们的使命与愿景',
    mission: {
      title: '使命',
      content: '通过创新技术和优质服务，赋能企业数字化转型，提升运营效率，驱动业务持续增长。'
    },
    vision: {
      title: '发展愿景',
      content: '成为亚太地区IT基础架构管理领域的信赖伙伴，通过技术创新与服务升级，助力客户实现基础设施现代化与业务增长协同。'
    }
  },
  
  certifications: {
    title: '资质认证',
    items: {
      iso9001: {
        name: 'ISO 9001',
        description: '质量管理体系认证'
      },
      iso27001: {
        name: 'ISO 27001',
        description: '信息安全管理认证'
      },
      idcIsp: {
        name: 'IDC/ISP',
        description: '中国大陆数据中心资质'
      },
      imda: {
        name: 'IMDA',
        description: '新加坡信息通信媒体发展局认证'
      },
      microsoft: {
        name: '微软合作伙伴',
        description: '金牌认证合作伙伴'
      },
      aws: {
        name: 'AWS合作伙伴',
        description: '高级咨询合作伙伴'
      },
      huawei: {
        name: '华为云合作伙伴',
        description: '解决方案伙伴'
      },
      award: {
        name: '行业卓越奖',
        description: '亚太IT服务创新奖'
      }
    }
  },
  
  serviceNetwork: {
    title: '亚太地区服务网络',
    subtitle: '覆盖 11 个亚太服务地区，与首页服务覆盖地图保持一致，提供本地化 IT 基础设施服务与区域协同交付能力',
    serviceScopeLabel: '服务范围',
    regions: {
      china: {
        name: '中国大陆',
        subtitle: '中国区服务中心',
        offices: {
          shanghai: {
            title: '上海服务中心',
            address: '上海市静安区西藏北路199号光明地产大厦1003-1室'
          },
          beijing: {
            title: '北京服务中心',
            address: 'No. 18, Jingjia Road, Yanqi Town, Huairou District, Beijing, China / 北京市怀柔区雁栖镇京加路18号'
          },
          guangzhou: {
            title: '深圳服务中心',
            address: 'Unit 55, Room 1407, Building B, Phase 1, Tian\'an Innovation Technology Plaza, No. 4 Tairan Road, Futian District, Shenzhen, China / 深圳市福田区天安创新科技广场一期B座1407-55'
          }
        },
        serviceScope: '中国大陆全境，提供数据中心建设与运维、云计算解决方案、网络安全服务及IT咨询服务'
      },
      hongkong: {
        name: '香港',
        subtitle: '香港服务中心',
        offices: {
          hq: {
            title: '香港服务中心',
            address: 'Room A, 1/F., Arthur Commercial Building, 33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong / 香港九龙油麻地鸦打街33号雅达商业大厦1楼A室'
          }
        },
        serviceScope: '香港地区及国际业务中转枢纽，提供跨境数据中心连接、国际网络服务及金融科技解决方案',
        highlight: {
          title: '国际业务优势',
          content: '作为连接中国内地与全球市场的桥梁，提供低延迟跨境数据传输和国际合规咨询服务'
        }
      },
      taiwan: {
        name: '台北',
        subtitle: '台北服务中心',
        offices: {
          taipei: {
            title: '台北服务中心',
            address: ''
          },
          hsinchu: {
            title: '新竹服务中心',
            address: ''
          }
        },
        serviceScope: '台湾地区全境，专注于高科技制造业IT解决方案、云计算服务及数据安全管理'
      },
      japan: {
        name: '日本',
        subtitle: '日本服务中心',
        offices: {
          tokyo: {
            title: '东京服务中心',
            address: '208, 2-9-17 HIGASHITABATA, KITA-KU, TOKYO 114-0013, JAPAN / 東京都北区東田端二丁目9番17-208号'
          },
          osaka: {
            title: '大阪服务中心',
            address: ''
          }
        },
        serviceScope: '日本全境，提供企业级IT基础设施管理、云计算迁移及日语本地化技术支持服务'
      },
      korea: {
        name: '韩国',
        subtitle: '韩国服务中心',
        offices: {
          seoul: {
            title: '首尔服务中心',
            address: ''
          }
        },
        serviceScope: '韩国全境及周边地区，专注于企业云转型、数据中心现代化及韩语技术支持服务',
        highlight: {
          title: '技术专长',
          content: '在半导体和电子制造行业IT解决方案方面拥有丰富经验和专业知识'
        }
      },
      singapore: {
        name: '新加坡',
        subtitle: '新加坡服务中心',
        offices: {
          hq: {
            title: '新加坡服务中心',
            address: '10 ANSON ROAD / #27-18 / INTERNATIONAL PLAZA / SINGAPORE (079903)'
          }
        },
        serviceScope: '新加坡及周边东南亚地区，提供区域IT基础设施管理、云服务及跨境数据合规解决方案',
        highlight: {
          title: '区域优势',
          content: '作为东南亚业务枢纽，提供多语言支持和符合东盟数据保护法规的IT解决方案'
        }
      }
    }
  },
  
  cta: {
    title: '立即体验我们的产品',
    description: 'Global Data 致力于为您提供最前沿的技术解决方案。我们的产品已经帮助数百家企业实现数字化转型，提升运营效率，驱动业务增长。',
    button: '联系我们'
  }
}
